import { ValueGetterParams } from 'ag-grid-community';
import { memoize } from 'lodash';

export interface DueDateValue {
  dueDate?: string;
  completedAt?: number;
}

export const dueDateValueGetter = memoize(
  (params: ValueGetterParams) => params.data as DueDateValue,
  (params) => {
    if (params.data == null) {
      return 'null';
    }
    const { dueDate, completedAt } = params.data;

    return `${dueDate}, ${completedAt}`;
  },
);
